import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Reason as s, transition as g } from "../components/transitions/utils/transition.js";
import { disposables as E } from "../utils/disposables.js";
import { match as n } from "../utils/match.js";
import { useDisposables as M } from "./use-disposables.js";
import { useEvent as a } from "./use-event.js";
import { useIsMounted as T } from "./use-is-mounted.js";
import { useIsoMorphicEffect as R } from "./use-iso-morphic-effect.js";
import { useLatestValue as j } from "./use-latest-value.js";

function H(_ref) {
  var u = _ref.container,
      o = _ref.direction,
      c = _ref.classes,
      t = _ref.events,
      d = _ref.onStart,
      l = _ref.onStop;
  var f = T(),
      m = M(),
      e = j(o),
      b = a(function () {
    return n(e.current, {
      enter: function enter() {
        return t.current.beforeEnter();
      },
      leave: function leave() {
        return t.current.beforeLeave();
      },
      idle: function idle() {}
    });
  }),
      p = a(function () {
    return n(e.current, {
      enter: function enter() {
        return t.current.afterEnter();
      },
      leave: function leave() {
        return t.current.afterLeave();
      },
      idle: function idle() {}
    });
  });
  R(function () {
    var r = E();
    m.add(r.dispose);
    var i = u.current;
    if (!!i && e.current !== "idle" && !!f.current) return r.dispose(), b(), d.current(e.current), r.add(g(i, c.current, e.current === "enter", function (v) {
      var _n;

      r.dispose(), n(v, (_n = {}, _defineProperty(_n, s.Ended, function () {
        p(), l.current(e.current);
      }), _defineProperty(_n, s.Cancelled, function () {}), _n));
    })), r.dispose;
  }, [o]);
}

export { H as useTransition };